export default "__VITE_ASSET__DKAwsF2P__"